export const ResponsiveService = {

    ref: null,

    is: (className) => ResponsiveService.ref.current.classList.contains(className),

    chat: {
        ref: {
            button: null,
            input: null,
        },
        toggle: () => {
            try {
                ResponsiveService.ref.current.classList.toggle('chat-is-open');
                // Set focus to aid accessibility
                if (ResponsiveService.is('chat-is-open')) {
                    ResponsiveService.chat.ref.input.current.focus();
                } else {
                    ResponsiveService.chat.ref.button.current.focus();
                }               
            } catch (err) {}
        }
    },

    reactions: {
        ref: {
            button: null,
            panel: null,
        },
        toggle: () => {
            try {
                ResponsiveService.ref.current.classList.toggle('reactions-is-open');
                // Set focus to aid accessibility
                if (ResponsiveService.is('reactions-is-open')) {
                    ResponsiveService.reactions.ref.panel.current.focus();
                              
                } else {
                    ResponsiveService.reactions.ref.button.current.focus();
                }
            } catch (err) {}
        }
    },

    video: {
        isPlaying: (isPlaying = false) => {
            try {
                ResponsiveService.ref.current.classList[isPlaying ? 'add' : 'remove']('video-is-playing');
            } catch (err) {}
        }
    }
};

export default ResponsiveService;